import type { GradeType } from "../../../../../common-deprecated/types/GradeType";

export const SET_GRADE = "model/setGrade" as const;

type SetGradeType = { type: typeof SET_GRADE; grade: GradeType };

export const setGrade = (grade: GradeType): SetGradeType => ({ type: SET_GRADE, grade });

export type GradeActionsType = SetGradeType;
